/* Built In Imports */
/* External Imports */
import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons';
import { Box, Text } from '@chakra-ui/react';
import Slider from 'react-slick';

/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';

/* Styles */
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import { pageCss } from './sections/ProgramDetails';

/**
 * Render Testimonial Component
 *
 * @param sectionContent.sectionContent
 * @param {object} sectionContent - Data from api
 * @returns {ReactElement} - Testimonial Component
 */
const Testimonial = ({ sectionContent }) => {
  const settingsSmall = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: <ChevronLeftIcon boxSize={8} cursor="pointer" />,
    nextArrow: <ChevronRightIcon boxSize={8} cursor="pointer" />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <Box
      bgColor={{ md: '#f5f0e5', base: 'transparent' }}
      m="19px auto 0 auto"
      px={{ base: '1rem', md: '2rem' }}
      maxW="1400px"
    >
      <Slider {...settingsSmall}>
        {sectionContent?.testimonials?.map((testimonial, index) => (
          <Box
            key={index}
            bgColor="#f5f0e5"
            display="flex"
            alignItems="center"
            justifyContent="flex-start"
            textAlign="center"
            p="20px"
            h="100%"
          >
            <LazyLoadImageComponent
              src={testimonial?.photo?.url}
              mr="1rem"
              height="170px"
              width="170px"
              borderRadius="50%"
            />
            <Box
              textAlign="left"
              lineHeight="29px"
              fontStyle="italic"
              pl="20px"
              flex="1"
            >
              {testimonial?.testimonialText}
              <br />
              <Text fontWeight="bold" pt="16px" fontStyle="normal">
                {testimonial?.userName}
              </Text>
            </Box>
          </Box>
        ))}
      </Slider>
      <style>
        {`
          .slick-next, .slick-next:focus, .slick-next:hover, .slick-prev, .slick-prev:focus, .slick-prev:hover
          {
            color: #000000;
          }
        `}
      </style>
    </Box>
  );
};

export default Testimonial;
